// Collect all the style into one place

import "@res/css/ngDialog/ngDialog.css"
import "@res/css/ngDialog/ngDialog-theme-plain.css"
import "@res/css/design-guide-toolkit/style.css"
import "@res/css/ngCsp/angular-csp.css"
import "@res/css/quill/quill.core.css"
import "@res/css/quill/quill.snow.css"

// Glob for all scss files under @app
// These will get extracted by the extractAppStyles webpack plugin
const req = require.context("@app", true, /\.scss$/)
req.keys().forEach(req);
